export interface FunctionRights {
  SystemFunctions: Array<SystemFunctionDTO>;
}

export interface SystemFunctionRights {
  FunctionRights: Array<FunctionRightDTO>;
}
export interface SystemFunctionDTO {
  Id: number;
  FunctionName: string;
  SystemScreen: SystemScreenDTO;
  Type: SystemFunctionTypeDTO;
  Description: string;
}

export interface FunctionRightDTO {
  FunctionId: number;
  FunctionName: string;
  ScreenId: number;
  ScreenName: string;
  Status: number;
  FunctionTypeId: number;
  FunctionTypeName: string;
}

export interface SystemFunctionTypeDTO {
  Id: number;
  TypeName: string;
}

export interface SystemScreenDTO {
  Id: number;
  ScreenName: string;
  Status: number;
}

export enum EnumSystemFunctions {
  None = 0,
  //RemTrackerTaskPage_Access = 1,
  RemTrackerTaskPage_View_Question = 1,
  RemTrackerTaskPage_EditTask = 2,
  RemTrackerTaskPage_SaveTask = 3,
  RemTrackerTaskPage_ChangeStatus = 4,
  RemTrackerTaskPage_DeleteLinked_Questions = 5,
  RemTrackerTaskPage_Submit_Review = 6,
  RemTrackerTaskPage_Submit_Closure = 7,
  RemTrackerTaskPage_Approval = 8,
  RemTrackerTaskPage_Reject = 9,
  RemTrackerTaskPage_Approval_For_Closure = 10,
  RemTrackerTaskPage_Reject_For_Closure = 11,
  RemTrackerTaskPage_Remove_Attachments = 12,
  //RemTrackerTasksPage_Access = 14,
  //RemTrackerTasksPage_View = 15,
  RemTrackerTasksPage_Create_ChildTask = 13,
  RemTrackerTasksPage_AddOrMergedTask = 14,
  RemTrackerTasksPage_Delete_childTask = 15,
  RemTrackerTasksPage_Export = 16,
  RemTrackerTasksPage_ColumnOptions = 17,
  RemTrackerTasksPage_ViewStatistics = 18,
  RemTrackerTasksPage_SaveUser_Preferences = 19,
  //SiteInspectionPage_Access = 23,
  //SiteInspectionPage_View = 24,
  SiteInspectionPage_Edit_TeamMembers = 20,
  SiteInspectionPage_CreateCopy = 21,
  SiteInspectionPage_Download_InspectionSummary = 22,
  SiteInspectionPage_StartStandard = 23,
  SiteInspectionPage_ResumeStandard = 24,
  SiteInspectionPage_CompleteStandard = 25,
  SiteInspectionPage_ReopenStandard = 26,
  //SiteInspectionPage_ViewStandard = 32,
  SiteInspectionPage_CloseInspection = 27,
  SiteInspectionPage_ReopenInspection = 28,
  SiteInspectionPage_Download_Standard_Summary = 29,
  SiteInspectionPage_New_Summary = 30,
  //QuestionnairePage_Access = 37,
  //QuestionnairePage_View = 38,
  QuestionnairePage_Edit_Intermediate = 31,
  QuestionnairePage_CompleteStandard = 32,
  QuestionnairePage_ClearAnswer = 33,
  QuestionnairePage_CreateCopy = 34,
  RemTrackerTaskPage_Edit_In_Pending_Review = 35,
  RemTrackerTaskPage_Edit_In_Pending_Closure_Approval = 36,
  //LocationPage_Access = 45,
  //StandardsPage_Access = 46,
  //InspectionSetTemplatesPage_Access = 47,
  //InspectionAssignmentsPage_Access = 48,
  SiteInspectionPage_ViewStatistics = 37,
  RemTrackerTaskPage_Approval_For_SME_Review = 38,
  RemTrackerTaskPage_Approval_For_Site_Review = 39,
  RemTrackerTaskPage_Reject_For_SME_Review = 40,
  RemTrackerTaskPage_Reject_For_Site_Review = 41,
  UserRoleManagementPage_View_User_Role = 42,
  UserRoleManagementPage_Edit_User_Role = 43,
  UserRoleManagementPage_View_User_Group = 44,
  UserRoleManagementPage_Add_User_Group = 45,
  UserRoleManagementPage_Edit_User_Group = 46,
  UserRoleManagementPage_Deactivate_User_Group = 47,
  RemTrackerTaskPage_CancelTask = 48,
  RemTrackerTasksPage_Export_TasksPendingApprovers = 49,
  RemTrackerTasksPage_Export_BasicStatistic = 50,
  UserProfilePage_View_Terms_Of_Use = 51,
  AssessmentTypeWizardPage_Add_Assessment_Type = 52,
  AssessmentTypeWizardPage_Edit_Assessment_Type = 53,
  AssessmentTypeWizardPage_View_Assessment_Type = 54,
  AssessmentTypeWizardPage_Deactivate_Assessment_Type = 55,
  AssessmentTypeWizardPage_Reactivate_Assessment_Type = 56,
  RemTrackerTaskPage_CloseTask = 57,
  SiteInspectionPage_GlobalSMEAssignment = 58,
  SiteInspectionPage_All_Summary = 59,
  QuestionnairePage_GlobalSMEApprove = 60,
  QuestionnairePage_GlobalSMEReject = 61,
  QuestionnairePage_OverwriteApprovedAnswers = 62,
  MultipleChoicesPage_Add_Multiple_Choices = 63,
  MultipleChoicesPage_Deactivate_Multiple_Choices = 64,
  MultipleChoicesPage_Edit_Multiple_Choices = 65,
  MultipleChoicesPage_View_Multiple_Choices = 66,
  SiteInspectionPage_Start_Offline_And_Cancel_Offline = 67,
  SiteInspectionPage_Download_Questionnaire_And_Upload_Answers = 68,
  InspectionSetandAssignmentPage_Create_Inspection_Set_Template = 69,
  InspectionSetandAssignmentPage_Edit_Inspection_Set_Template = 70,
  InspectionSetandAssignmentPage_Schedule_Inspections = 71,
  InspectionSetandAssignmentPage_Edit_Inspection = 72,
  InspectionSetandAssignmentPage_Delete_Inspection = 73,
  InspectionSetandAssignmentPage_View_Inspections = 74,
  InspectionSetandAssignmentPage_Export_Inspection_Set_Questions = 75,
  StandardsPage_Create_Standard = 76,
  StandardPage_Edit_Standard = 77,
  StandardPage_Deactivate_Standard = 78,
  StandardsQuestionsPage_View_Question = 79,
  StandardsQuestionsPage_Add_New_Question = 80,
  StandardsQuestionsPage_Bulk_Question_Upload = 81,
  QuestionPage_Edit_Question_Template = 82,
  QuestionPage_Deactivate_Question_Template = 83,
  ReferencePage_View_Reference = 84,
  ReferencePage_Add_New_Reference = 85,
  ReferencePage_Edit_Reference = 86,
  ReferencePage_Deactivate_Reference = 87,
  SystemPage_View_System = 88,
  SystemPage_Add_New_System = 89,
  SystemPage_Edit_System = 90,
  SystemPage_Deactivate_System = 91,
  SubSystemPage_View_SubSystem = 92,
  SubSystemPage_Add_New_SubSystem = 93,
  SubSystemPage_Edit_SubSystem = 94,
  SubSystemPage_Deactivate_SubSystem = 95,
  SubjectPage_View_Subject = 96,
  SubjectPage_Add_New_Subject = 97,
  SubjectPage_Edit_Subject = 98,
  SubjectPage_Deactivate_Subject = 99,
  SectionPage_View_Section = 100,
  SectionPage_Add_New_Section = 101,
  SectionPage_Edit_Section = 102,
  SectionPage_Deactivate_Section = 103,
  StandardsQuestionsPage_Export_All_Questions = 104,
  StandardsQuestionsPage_Export_Filtered_Records = 105,
  QuestionnairePage_DeleteAssignedQuestion = 106,
  RemTrackerTaskPage_ReOpenTask = 107,
}
export enum EnumSystemFunctionTypes {
  None = 0,
  AccessPage = 1,
  ViewPage = 2,
  ButtonAccess = 3,
}
